import peopleAndNotificationsData from '@/constants/peopleAndNotifications';

export default {
    namespaced: true,
    state: {
        groups: peopleAndNotificationsData.data
    }
};
